import commonPostTypeConfig from '../../common/postTypes/transaction'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'transaction',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
